// Display Languages List (Matching YouTube)
export const DISPLAY_LANGUAGES = [
  { code: 'af', name: 'Afrikaans' },
  { code: 'az', name: 'Azərbaycanca' },
  { code: 'id', name: 'Bahasa Indonesia' },
  { code: 'ms', name: 'Bahasa Malaysia' },
  { code: 'bs', name: 'Bosanski' },
  { code: 'ca', name: 'Català' },
  { code: 'cs', name: 'Čeština' },
  { code: 'da', name: 'Dansk' },
  { code: 'de', name: 'Deutsch' },
  { code: 'et', name: 'Eesti' },
  { code: 'en-IN', name: 'English (India)' },
  { code: 'en-GB', name: 'English (UK)' },
  { code: 'en', name: 'English (US)' },
  { code: 'es-ES', name: 'Español (España)' },
  { code: 'es-419', name: 'Español (Latinoamérica)' },
  { code: 'es-US', name: 'Español (US)' },
  { code: 'eu', name: 'Euskara' },
  { code: 'fil', name: 'Filipino' },
  { code: 'fr', name: 'Français' },
  { code: 'fr-CA', name: 'Français (Canada)' },
  { code: 'gl', name: 'Galego' },
  { code: 'hr', name: 'Hrvatski' },
  { code: 'zu', name: 'IsiZulu' },
  { code: 'is', name: 'Íslenska' },
  { code: 'it', name: 'Italiano' },
  { code: 'sw', name: 'Kiswahili' },
  { code: 'lv', name: 'Latviešu' },
  { code: 'lt', name: 'Lietuvių' },
  { code: 'hu', name: 'Magyar' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'no', name: 'Norsk' },
  { code: 'pl', name: 'Polski' },
  { code: 'pt-BR', name: 'Português (Brasil)' },
  { code: 'pt-PT', name: 'Português (Portugal)' },
  { code: 'ro', name: 'Română' },
  { code: 'sk', name: 'Slovenčina' },
  { code: 'sl', name: 'Slovenščina' },
  { code: 'fi', name: 'Suomi' },
  { code: 'sv', name: 'Svenska' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'el', name: 'Ελληνικά' },
  { code: 'bg', name: 'Български' },
  { code: 'ru', name: 'Русский' },
  { code: 'uk', name: 'Українська' },
  { code: 'he', name: 'עברית' },
  { code: 'ar', name: 'العربية' },
  { code: 'fa', name: 'فارسی' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'mr', name: 'मराठी' },
  { code: 'bn', name: 'বাংলা' },
  { code: 'pa', name: 'ਪੰਜਾਬੀ' },
  { code: 'gu', name: 'ગુજરાતી' },
  { code: 'ta', name: 'தமிழ்' },
  { code: 'te', name: 'తెలుగు' },
  { code: 'kn', name: 'कन्नड' },
  { code: 'ml', name: 'മലയാളം' },
  { code: 'ne', name: 'नेपाली (Nepali)' },
  { code: 'th', name: 'ไทย' },
  { code: 'ko', name: '한국어' },
  { code: 'ja', name: '日本語' },
  { code: 'zh-CN', name: '简体中文' },
  { code: 'zh-TW', name: '繁體中文' },
];

// UI Translation Dictionary for core UI keys across key languages
export const UI_TRANSLATIONS = {
  en: {
    search: 'Search',
    create: 'Create',
    signIn: 'Sign in',
    appearance: 'Appearance: Device theme',
    displayLanguage: 'Display language',
    albums: 'Albums',
    settings: 'Settings',
    logout: 'Log out',
    help: 'Help & feedback',
    home: 'Home',
    shorts: 'Shorts',
    subscriptions: 'Subscriptions',
    you: 'You',
    history: 'History',
    playlists: 'Playlists',
    yourVideos: 'Your videos',
    watchLater: 'Watch later',
    likedVideos: 'Liked videos',
    explore: 'Explore',
    trending: 'Trending',
    music: 'Music',
    gaming: 'Gaming',
    news: 'News',
    sports: 'Sports',
    podcasts: 'Podcasts',
    welcomeTitle: 'Welcome to SpeedoTube',
    welcomeMessage: 'Sign in to immerse yourself in a wide range of entertainment and discover what unfolds in the tapestry of human life.',
    exploreAnyways: 'Explore Anyways',
    all: 'All',
    live: 'Live',
    soundtracks: 'Soundtracks',
    mixes: 'Mixes',
    recentlyUploaded: 'Recently uploaded',
    yourChannel: 'Your channel',
    downloads: 'Downloads',
    moreFromSpeedo: 'More from Speedo',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    shopping: 'Shopping',
    movies: 'Movies & TV',
    popular: 'Popular Channels',
    day: 'Videos of the Day',
    week: 'Videos of the Week',
    month: 'Videos of the Month',
    year: 'Videos of the Year',
    programming: 'Computer programming',
    thoughts: 'Thoughts',
    inventions: 'Inventions',
    react: 'React JS',
    php: 'PHP & MySQL',
    cloud: 'Cloud Storage',
    tech: 'Tech Reviews',
    gadgets: 'Gadgets',
    speedotube: 'SpeedoTube',
    watched: 'Watched',
    newToYou: 'New to you',
    views: 'views',
    ago: 'ago',
    daysAgo: 'days ago',
    dayAgo: 'day ago',
    hoursAgo: 'hours ago',
    hourAgo: 'hour ago',
    weekAgo: 'week ago',
    weeksAgo: 'weeks ago',
    monthAgo: 'month ago',
    monthsAgo: 'months ago',
    streamedLive: 'Streamed live',
    sponsored: 'SPONSORED',
    ad: 'AD',
    featured: 'FEATURED',
    startLearning: 'Start Learning',
    tryFree: 'Try Free for 30 Days',
    streamNow: 'Stream Now',
    getStarted: 'Get Started',
    showMore: 'Show more',
    showLess: 'Show less',
  },
  af: {
    search: 'Soek',
    create: 'Skep',
    signIn: 'Meld aan',
    appearance: 'Voorkoms: Toestel-tema',
    displayLanguage: 'Vertoon-taal',
    albums: 'Albums',
    settings: 'Instellings',
    logout: 'Teken uit',
    help: 'Hulp en terugvoer',
    home: 'Tuis',
    shorts: 'Shorts',
    subscriptions: 'Intekeninge',
    you: 'Jy',
    history: 'Geskiedenis',
    playlists: 'Snitlyste',
    yourVideos: 'Jouself se video’s',
    watchLater: 'Kyk later',
    likedVideos: 'Gelaaide video’s',
    yourChannel: 'Jou kanaal',
    downloads: 'Aflaai-lêers',
    moreFromSpeedo: 'Meer van Speedo',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Verken',
    shopping: 'Inkopies',
    music: 'Musiek',
    movies: 'Flieks en TV',
    trending: 'Gewild',
    popular: 'Gewilde kanale',
    day: 'Video’s van die dag',
    week: 'Video’s van die week',
    month: 'Video’s van die maand',
    year: 'Video’s van die jaar',
    showMore: 'Wys meer',
    showLess: 'Wys minder',
    gaming: 'Speletjies',
    news: 'Nuus',
    sports: 'Sport',
    podcasts: 'Podsendings',
    welcomeTitle: 'Welkom by SpeedoTube',
    welcomeMessage: 'Meld aan om die beste vermaking te geniet.',
    exploreAnyways: 'Verken in elk geval',
    all: 'Alles',
    live: 'Regstreeks',
    views: 'kyke',
  },
  az: {
    search: 'Axtar',
    create: 'Yaradın',
    signIn: 'Daxil olun',
    appearance: 'Görünüş: Cihaz mövzusu',
    displayLanguage: 'Göstərilmə dili',
    albums: 'Albomlar',
    settings: 'Ayarlar',
    logout: 'Çıxış',
    help: 'Kömək və rəylər',
    home: 'Ana səhifə',
    shorts: 'Shorts',
    subscriptions: 'Abunəliklər',
    you: 'Siz',
    history: 'Tarixçə',
    playlists: 'Pley-listlər',
    yourVideos: 'Videolarınız',
    watchLater: 'Sonra baxın',
    likedVideos: 'Bəyənilən videolar',
    yourChannel: 'Kanalınız',
    downloads: 'Yükləmələr',
    moreFromSpeedo: 'Speedo-dan daha çox',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Kəşf edin',
    shopping: 'Pərakəndə satış',
    music: 'Musiqi',
    movies: 'Filmlər və TV',
    trending: 'Trendlər',
    popular: 'Məşhur kanallar',
    day: 'Günün videoları',
    week: 'Həftənin videoları',
    month: 'Ayın videoları',
    year: 'İlin videoları',
    showMore: 'Daha çox göster',
    showLess: 'Daha az göster',
    gaming: 'Oyunlar',
    news: 'Xəbərlər',
    sports: 'Idman',
    podcasts: 'Podkastlar',
    welcomeTitle: 'SpeedoTube-a xoş gəlmisiniz',
    welcomeMessage: 'Əyləncədən həzz almaq üçün daxil olun.',
    exploreAnyways: 'Yenə də kəşf edin',
    all: 'Hamısı',
    live: 'Canlı',
    views: 'baxış',
  },
  id: {
    search: 'Telusuri',
    create: 'Buat',
    signIn: 'Login',
    appearance: 'Tampilan: Tema perangkat',
    displayLanguage: 'Bahasa tampilan',
    albums: 'Album',
    settings: 'Setelan',
    logout: 'Logout',
    help: 'Bantuan & masukan',
    home: 'Beranda',
    shorts: 'Shorts',
    subscriptions: 'Subskripsi',
    you: 'Anda',
    history: 'Histori',
    playlists: 'Playlist',
    yourVideos: 'Video Anda',
    watchLater: 'Tonton nanti',
    likedVideos: 'Video yang disukai',
    yourChannel: 'Channel Anda',
    downloads: 'Download',
    moreFromSpeedo: 'Lainnya dari Speedo',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Eksplorasi',
    shopping: 'Shopping',
    music: 'Musik',
    movies: 'Film & TV',
    trending: 'Trending',
    popular: 'Channel populer',
    day: 'Video hari ini',
    week: 'Video minggu ini',
    month: 'Video bulan ini',
    year: 'Video tahun ini',
    showMore: 'Tampilkan lebih banyak',
    showLess: 'Tampilkan lebih sedikit',
    gaming: 'Game',
    news: 'Berita',
    sports: 'Olahraga',
    podcasts: 'Podcast',
    welcomeTitle: 'Selamat datang di SpeedoTube',
    welcomeMessage: 'Login untuk menikmati hiburan terbaik.',
    exploreAnyways: 'Tetap jelajahi',
    all: 'Semua',
    live: 'Live',
    views: 'x ditonton',
  },
  ms: {
    search: 'Cari',
    create: 'Cipta',
    signIn: 'Log masuk',
    appearance: 'Penampilan: Tema peranti',
    displayLanguage: 'Bahasa paparan',
    albums: 'Album',
    settings: 'Tetapan',
    logout: 'Log keluar',
    help: 'Bantuan & maklum balas',
    home: 'Laman Utama',
    shorts: 'Shorts',
    subscriptions: 'Langganan',
    you: 'Anda',
    history: 'Sejarah',
    playlists: 'Senarai main',
    yourVideos: 'Video anda',
    watchLater: 'Tonton kemudian',
    likedVideos: 'Video disukai',
    yourChannel: 'Saluran anda',
    downloads: 'Muat turun',
    moreFromSpeedo: 'Lagi daripada Speedo',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Terokai',
    shopping: 'Membeli-belah',
    music: 'Muzik',
    movies: 'Filem & TV',
    trending: 'Trending',
    popular: 'Saluran popular',
    day: 'Video hari ini',
    week: 'Video minggu ini',
    month: 'Video bulan ini',
    year: 'Video tahun ini',
    showMore: 'Tunjukkan lagi',
    showLess: 'Tunjukkan kurang',
    gaming: 'Permainan',
    news: 'Berita',
    sports: 'Sukan',
    podcasts: 'Podsiar',
    welcomeTitle: 'Selamat datang ke SpeedoTube',
    welcomeMessage: 'Log masuk untuk menikmati hiburan.',
    exploreAnyways: 'Terokai jua',
    all: 'Semua',
    live: 'Langsung',
    views: 'tontonan',
  },
  pa: {
    search: 'ਖੋਜੋ',
    create: 'ਬਣਾਓ',
    signIn: 'ਸਾਈਨ ਇਨ',
    appearance: 'ਦਿੱਖ: ਡਿਵਾਈਸ ਥੀਮ',
    displayLanguage: 'ਡਿਸਪਲੇ ਭਾਸ਼ਾ',
    albums: 'ਐਲਬਮਾਂ',
    settings: 'ਸੈਟਿੰਗਾਂ',
    logout: 'ਲੌਗ ਆਉਟ',
    help: 'ਮਦਦ ਅਤੇ ਫੀਡਬੈਕ',
    home: 'ਮੁੱਖ ਪੰਨਾ',
    shorts: 'ਸ਼ੋਰਟਸ',
    subscriptions: 'ਸਬਸਕ੍ਰਿਪਸ਼ਨ',
    you: 'ਤੁਸੀਂ',
    history: 'ਇਤਿਹਾਸ',
    playlists: 'ਪਲੇਲਿਸਟਾਂ',
    yourVideos: 'ਤੁਹਾਡੇ ਵੀਡੀਓ',
    watchLater: 'ਬਾਅਦ ਵਿੱਚ ਦੇਖੋ',
    likedVideos: 'ਪਸੰਦ ਕੀਤੇ ਵੀਡੀਓ',
    explore: 'ਐਕਸਪਲੋਰ',
    trending: 'ਟ੍ਰੈਂਡਿੰਗ',
    music: 'ਸੰਗੀਤ',
    gaming: 'ਗੇਮਿੰਗ',
    news: 'ਖ਼ਬਰਾਂ',
    sports: 'ਖੇਡਾਂ',
    podcasts: 'ਪੋਡਕਾਸਟ',
    welcomeTitle: 'ਸਪੀਡੋਟਿਊਬ ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ',
    welcomeMessage: 'ਮਨੋਰੰਜਨ ਦਾ ਆਨੰਦ ਲੈਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ।',
    exploreAnyways: 'ਇਵੇਂ ਹੀ ਦੇਖੋ',
    all: 'ਸਭ',
    live: 'ਲਾਈਵ',
    soundtracks: 'ਸਾਊਂਡਟ੍ਰੈਕ',
    mixes: 'ਮਿਕਸ',
    recentlyUploaded: 'ਹਾਲ ਹੀ ਵਿੱਚ ਅੱਪਲੋਡ ਕੀਤਾ ਗਿਆ',
  },
  mr: {
    search: 'शोधा',
    create: 'तयार करा',
    signIn: 'साइन इन करा',
    appearance: 'देखावा: डिव्हाइस थीम',
    displayLanguage: 'प्रदर्शित भाषा',
    albums: 'अल्बम',
    settings: 'सेटिंग्ज',
    logout: 'लॉग आउट',
    help: 'मदत आणि अभिप्राय',
    home: 'घर (होम)',
    shorts: 'शॉर्ट्स',
    subscriptions: 'सदस्यता',
    you: 'तुम्ही',
    history: 'इतिहास',
    playlists: 'प्लेलिस्ट',
    yourVideos: 'तुमचे व्हिडिओ',
    watchLater: 'नंतर पहा',
    likedVideos: 'आवडलेले व्हिडिओ',
    explore: 'एक्सप्लोर करा',
    trending: 'ट्रेंडिंग',
    music: 'संगीत',
    gaming: 'गेमिंग',
    news: 'बातम्या',
    sports: 'क्रीडा',
    podcasts: 'पॉडकास्ट',
    welcomeTitle: 'स्पीडोट्यूबमध्ये आपले स्वागत आहे',
    welcomeMessage: 'मनोरंजनाच्या जगात प्रवेश करण्यासाठी साइन इन करा.',
    exploreAnyways: 'असेच एक्सप्लोर करा',
    all: 'सर्व',
    live: 'थेट (लाइव्ह)',
    soundtracks: 'साउंडट्रॅक',
    mixes: 'मिक्स',
    recentlyUploaded: 'अलीकडेच अपलोड केलेले',
    yourChannel: 'तुमचे चॅनेल',
    downloads: 'डाउनलोड्स',
    moreFromSpeedo: 'स्पीडो कडून अधिक',
    speedoPrime: 'स्पीडो प्राइम',
    speedoTV: 'स्पीडो टीव्ही',
    speedoLearning: 'स्पीडो लर्निंग',
    shopping: 'खरेदी',
    movies: 'चित्रपट आणि टीव्ही',
    popular: 'लोकप्रिय चॅनेल',
    day: 'दिवसाचे व्हिडिओ',
    week: 'आठवड्याचे व्हिडिओ',
    month: 'महिन्याचे व्हिडिओ',
    year: 'वर्षाचे व्हिडिओ',
    programming: 'संगणक प्रोग्रामिंग',
    thoughts: 'विचार',
    inventions: 'शोध',
    react: 'रिएक्ट जेएस',
    php: 'पीएचपी आणि मायएसक्यूएल',
    cloud: 'क्लाउड स्टोरेज',
    tech: 'टेक पुनरावलोकने',
    gadgets: 'गॅझेट्स',
    speedotube: 'स्पीडोट्यूब',
    watched: 'पाहिलेले',
    newToYou: 'तुमच्यासाठी नवीन',
    views: 'दृश्ये',
    ago: 'पूर्वी',
    daysAgo: 'दिवसांपूर्वी',
    hoursAgo: 'तासांपूर्वी',
    weekAgo: 'आठवड्यापूर्वी',
    weeksAgo: 'आठवड्यांपूर्वी',
    monthAgo: 'महिन्यापूर्वी',
    streamedLive: 'थेट प्रवाहित केले',
    sponsored: 'प्रायोजित',
    ad: 'जाहिरात',
    featured: 'वैशिष्ट्यीकृत',
    startLearning: 'शिकण्यास प्रारंभ करा',
    tryFree: '३० दिवस विनामूल्य वापरून पहा',
    streamNow: 'आत्ताच स्ट्रीम करा',
    getStarted: 'सुरू करा',
    listenNow: 'आता ऐका',
  },
  hi: {
    search: 'खोजें',
    create: 'बनाएं',
    signIn: 'साइन इन करें',
    appearance: 'रंग-रूप: डिवाइस थीम',
    displayLanguage: 'डिस्प्ले भाषा',
    albums: 'एल्बम',
    settings: 'सेटिंग्स',
    logout: 'साइन आउट',
    help: 'सहायता और फ़ीडबैक',
    home: 'होम',
    shorts: 'शॉर्ट्स',
    subscriptions: 'सदस्यताएँ',
    you: 'आप',
    history: 'इतिहास',
    playlists: 'प्लेलिस्ट',
    yourVideos: 'आपके वीडियो',
    watchLater: 'बाद में देखें',
    likedVideos: 'पसंद किए गए वीडियो',
    explore: 'एक्सप्लोर करें',
    trending: 'ट्रेंडिंग',
    music: 'संगीत',
    gaming: 'गेमिंग',
    news: 'समाचार',
    sports: 'खेल',
    podcasts: 'पॉडकास्ट',
    welcomeTitle: 'स्पीडोट्यूब में आपका स्वागत है',
    welcomeMessage: 'मनोरंजन की दुनिया में डूबने के लिए साइन इन करें।',
    exploreAnyways: 'ऐसे ही देखें',
    all: 'सभी',
    live: 'लाइव',
    soundtracks: 'साउंडट्रैक',
    mixes: 'मिक्स',
    recentlyUploaded: 'हाल ही में अपलोड किया गया',
    yourChannel: 'आपका चैनल',
    downloads: 'डाउनलोड',
    moreFromSpeedo: 'स्पीडो की ओर से और',
    speedoPrime: 'स्पीडो प्राइम',
    speedoTV: 'स्पीडो टीवी',
    speedoLearning: 'स्पीडो लर्निंग',
    shopping: 'खरीदारी',
    movies: 'फ़िल्में और टीवी',
    popular: 'लोकप्रिय चैनल',
    day: 'आज के वीडियो',
    week: 'इस सप्ताह के वीडियो',
    month: 'इस महीने के वीडियो',
    year: 'इस साल के वीडियो',
    programming: 'कंप्यूटर प्रोग्रामिंग',
    thoughts: 'विचार',
    inventions: 'आविष्कार',
    react: 'रिएक्ट जेएस',
    php: 'पीएचपी और मायएसक्यूएल',
    cloud: 'क्लाउड स्टोरेज',
    tech: 'टेक समीक्षाएं',
    gadgets: 'गैजेट्स',
    speedotube: 'स्पीडोट्यूब',
    watched: 'देखे गए',
    newToYou: 'आपके लिए नए',
    views: 'बार देखा गया',
    ago: 'पहले',
    daysAgo: 'दिन पहले',
    hoursAgo: 'घंटे पहले',
    weekAgo: 'हफ़्ते पहले',
    weeksAgo: 'हफ़्ते पहले',
    monthAgo: 'महीने पहले',
    streamedLive: 'लाइव स्ट्रीम किया गया',
    sponsored: 'प्रायोजित',
    ad: 'विज्ञापन',
    featured: 'खास',
    startLearning: 'सीखना शुरू करें',
    tryFree: '30 दिनों के लिए मुफ्त आज़माएं',
    streamNow: 'अभी स्ट्रीम करें',
    getStarted: 'शुरू करें',
    listenNow: 'अभी सुनें',
  },
  es: {
    search: 'Buscar',
    create: 'Crear',
    signIn: 'Iniciar sesión',
    appearance: 'Aspecto: Tema del dispositivo',
    displayLanguage: 'Idioma de visualización',
    albums: 'Álbumes',
    settings: 'Configuración',
    logout: 'Cerrar sesión',
    help: 'Ayuda y comentarios',
    home: 'Inicio',
    shorts: 'Shorts',
    subscriptions: 'Suscripciones',
    you: 'Tú',
    history: 'Historial',
    playlists: 'Listas de reproducción',
    yourVideos: 'Tus vídeos',
    watchLater: 'Ver más tarde',
    likedVideos: 'Vídeos que me gustan',
    explore: 'Explorar',
    trending: 'Tendencias',
    music: 'Música',
    gaming: 'Videojuegos',
    news: 'Noticias',
    sports: 'Deportes',
    podcasts: 'Pódcasts',
    welcomeTitle: 'Bienvenido a SpeedoTube',
    welcomeMessage: 'Inicia sesión para disfrutar del mejor entretenimiento.',
    exploreAnyways: 'Explorar de todos modos',
    all: 'Todo',
    live: 'En directo',
    soundtracks: 'Bandas sonoras',
    mixes: 'Mixes',
    recentlyUploaded: 'Subido recientemente',
  },
  fr: {
    search: 'Rechercher',
    create: 'Créer',
    signIn: 'Se connecter',
    appearance: 'Apparence : Thème de l\'appareil',
    displayLanguage: 'Langue d\'affichage',
    albums: 'Albums',
    settings: 'Paramètres',
    logout: 'Se déconnecter',
    help: 'Aide et commentaires',
    home: 'Accueil',
    shorts: 'Shorts',
    subscriptions: 'Abonnements',
    you: 'Vous',
    history: 'Historique',
    playlists: 'Playlists',
    yourVideos: 'Vos vidéos',
    watchLater: 'À regarder plus tard',
    likedVideos: 'Vidéos "J\'aime"',
    explore: 'Explorer',
    trending: 'Tendances',
    music: 'Musique',
    gaming: 'Jeux vidéo',
    news: 'Actualités',
    sports: 'Sports',
    podcasts: 'Podcasts',
    welcomeTitle: 'Bienvenue sur SpeedoTube',
    welcomeMessage: 'Connectez-vous pour profiter d\'un divertissement illimité.',
    exploreAnyways: 'Explorer quand même',
    all: 'Tous',
    live: 'En direct',
    soundtracks: 'Bandes originales',
    mixes: 'Mixes',
    recentlyUploaded: 'Ajoutés récemment',
  },
  de: {
    search: 'Suchen',
    create: 'Erstellen',
    signIn: 'Anmelden',
    appearance: 'Erscheinungsbild: Gerätethema',
    displayLanguage: 'Sprache',
    albums: 'Alben',
    settings: 'Einstellungen',
    logout: 'Abmelden',
    help: 'Hilfe & Feedback',
    home: 'Startseite',
    shorts: 'Shorts',
    subscriptions: 'Abonnements',
    you: 'Ich',
    history: 'Verlauf',
    playlists: 'Playlists',
    yourVideos: 'Deine Videos',
    watchLater: 'Später ansehen',
    likedVideos: 'Videos, die dir gefallen',
    explore: 'Erkunden',
    trending: 'Trends',
    music: 'Musik',
    gaming: 'Gaming',
    news: 'Nachrichten',
    sports: 'Sport',
    podcasts: 'Podcasts',
    welcomeTitle: 'Willkommen bei SpeedoTube',
    welcomeMessage: 'Melde dich an, um beste Unterhaltung zu genießen.',
    exploreAnyways: 'Trotzdem erkunden',
    all: 'Alle',
    live: 'Live',
    soundtracks: 'Soundtracks',
    mixes: 'Mixes',
    recentlyUploaded: 'Neuerlich hochgeladen',
  },
  ro: {
    search: 'Caută',
    create: 'Creează',
    signIn: 'Conectare',
    appearance: 'Aspect: Tema dispozitivului',
    displayLanguage: 'Limba afișată',
    albums: 'Albume',
    settings: 'Setări',
    logout: 'Deconectare',
    help: 'Ajutor și feedback',
    home: 'Acasă',
    shorts: 'Shorts',
    subscriptions: 'Abonamente',
    you: 'Tu',
    history: 'Istoric',
    playlists: 'Playlisturi',
    yourVideos: 'Videoclipurile tale',
    watchLater: 'Vizionează mai târziu',
    likedVideos: 'Videoclipuri apreciate',
    explore: 'Explorează',
    trending: 'In tendințe',
    music: 'Muzică',
    gaming: 'Jocuri',
    news: 'Știri',
    sports: 'Sport',
    podcasts: 'Podcasturi',
    welcomeTitle: 'Bun venit la SpeedoTube',
    welcomeMessage: 'Conectează-te pentru a te bucura de divertisment de calitate.',
    exploreAnyways: 'Explorează oricum',
    all: 'Toate',
    live: 'Live',
    soundtracks: 'Coloane sonore',
    mixes: 'Mixaje',
    recentlyUploaded: 'Încărcate recent',
  },
  ne: {
    search: 'खोज्नुहोस्',
    create: 'सिर्जना गर्नुहोस्',
    signIn: 'साइन इन गर्नुहोस्',
    appearance: 'रूप: उपकरण विषयवस्तु',
    displayLanguage: 'प्रदर्शन भाषा',
    albums: 'एल्बमहरू',
    settings: 'सेटिङहरू',
    logout: 'साइन आउट',
    help: 'सहायता र प्रतिक्रिया',
    home: 'गृह',
    shorts: 'शर्ट्स',
    subscriptions: 'सदस्यताहरू',
    you: 'तपाईं',
    history: 'इतिहास',
    playlists: 'प्लेलिस्टहरू',
    yourVideos: 'तपाईंका भिडियोहरू',
    watchLater: 'पछि हेर्नुहोस्',
    likedVideos: 'मन परेका भिडियोहरू',
    explore: 'अन्वेषण गर्नुहोस्',
    trending: 'ट्रेन्डिङ',
    music: 'संगीत',
    gaming: 'गेमिङ',
    news: 'समाचार',
    sports: 'खेलकुद',
    podcasts: 'पडकास्टहरू',
    welcomeTitle: 'स्पीडोट्यूबमा स्वागत छ',
    welcomeMessage: 'मनोरञ्जनको आनन्द लिन साइन इन गर्नुहोस्।',
    exploreAnyways: 'त्यसै अन्वेषण गर्नुहोस्',
    all: 'सबै',
    live: 'लाइभ',
    soundtracks: 'साउन्डट्र्याकहरू',
    mixes: 'मिक्सहरू',
    recentlyUploaded: 'भर्खरै अपलोड गरिएको',
  },
  gu: {
    search: 'શોધો',
    create: 'બનાવો',
    signIn: 'સાઇન ઇન કરો',
    appearance: 'દેખાવ: ઉપકરણ થીમ',
    displayLanguage: 'ડિસ્પ્લે ભાષા',
    albums: 'આલ્બમ્સ',
    settings: 'સેટિંગ્સ',
    logout: 'સાઇન આઉટ',
    help: 'મદદ અને પ્રતિસાદ',
    home: 'હોમ',
    shorts: 'શોર્ટ્સ',
    subscriptions: 'સબ્સ્ક્રિપ્શન્સ',
    you: 'તમે',
    history: 'ઇતિહાસ',
    playlists: 'પ્લેલિસ્ટ્સ',
    yourVideos: 'તમારા વીડિયો',
    watchLater: 'પછીથી જુઓ',
    likedVideos: 'ગમેલા વીડિયો',
    explore: 'એક્સપ્લોર કરો',
    trending: 'ટ્રેન્ડિંગ',
    music: 'સંગીત',
    gaming: 'ગેમિંગ',
    news: 'સમાચાર',
    sports: 'રમતગમત',
    podcasts: 'પોડકાસ્ટ',
    welcomeTitle: 'સ્પીડોટ્યુબમાં આપનું સ્વાગત છે',
    welcomeMessage: 'મનોરંજન માણવા માટે સાઇન ઇન કરો.',
    exploreAnyways: 'એમ જ આગળ વધો',
    all: 'બધા',
    live: 'લાઇવ',
    soundtracks: 'સાઉન્ડટ્રેક',
    mixes: 'મિક્સ',
    recentlyUploaded: 'તાજેતરમાં અપલોડ કરેલ',
  },
  bn: {
    search: 'অনুসন্ধান করুন',
    create: 'তৈরি করুন',
    signIn: 'সাইন ইন করুন',
    appearance: 'চেহারা: ডিভাইস থিম',
    displayLanguage: 'প্রদর্শন ভাষা',
    albums: 'অ্যালবাম',
    settings: 'সেটিংস',
    logout: 'সাইন আউট',
    help: 'সহায়তা ও প্রতিক্রিয়া',
    home: 'হোম',
    shorts: 'শর্টস',
    subscriptions: 'সাবস্ক্রিপশন',
    you: 'আপনি',
    history: 'ইতিহাস',
    playlists: 'প্লেলিস্ট',
    yourVideos: 'আপনার ভিডিও',
    watchLater: 'পরে দেখুন',
    likedVideos: 'পছন্দ করা ভিডিও',
    explore: 'এক্সপ্লোর করুন',
    trending: 'ট্রেন্ডিং',
    music: 'সঙ্গীত',
    gaming: 'গেমিং',
    news: 'সংবাদ',
    sports: 'খেলাধুলা',
    podcasts: 'পডকাস্ট',
    welcomeTitle: 'স্পিডোট্যুবে স্বাগতম',
    welcomeMessage: 'বিনোদন উপভোগ করতে সাইন ইন করুন।',
    exploreAnyways: 'এমনিতেই এক্সপ্লোর করুন',
    all: 'সব',
    live: 'লাইভ',
    soundtracks: 'সাউন্ডট্র্যাক',
    mixes: 'মিক্স',
    recentlyUploaded: 'সম্প্রতি আপলোড করা হয়েছে',
  },
  ta: {
    search: 'தேடு',
    create: 'உருவாக்கு',
    signIn: 'உள்நுழை',
    appearance: 'தோற்றம்: சாதன தீம்',
    displayLanguage: 'காட்சி மொழி',
    albums: 'ஆல்பங்கள்',
    settings: 'அமைப்புகள்',
    logout: 'வெளியேறு',
    help: 'உதவி & கருத்துகள்',
    home: 'முகப்பு',
    shorts: 'ஷாட்ஸ்',
    subscriptions: 'சந்தாக்கள்',
    you: 'நீங்கள்',
    history: 'வரலாறு',
    playlists: 'ப்ளேலிஸ்ட்கள்',
    yourVideos: 'உங்கள் வீடியோக்கள்',
    watchLater: 'பின்னர் பார்க்க',
    likedVideos: 'பிடித்த வீடியோக்கள்',
    explore: 'ஆராயுங்கள்',
    trending: 'ட்ரெண்டிங்',
    music: 'இசை',
    gaming: 'கேமிங்',
    news: 'செய்திகள்',
    sports: 'விளையாட்டு',
    podcasts: 'பாட்காஸ்ட்கள்',
    welcomeTitle: 'ஸ்பீடோடியூப்பிற்கு வரவேற்கிறோம்',
    welcomeMessage: 'சிறந்த பொழுதுபோக்கை அனுபவிக்க உள்நுழையவும்.',
    exploreAnyways: 'ஆராயுங்கள்',
    all: 'எல்லாம்',
    live: 'லைவ்',
    views: 'பார்வைகள்',
    daysAgo: 'நாட்களுக்கு முன்',
    hoursAgo: 'மணிநேரத்திற்கு முன்',
  },
  te: {
    search: 'శోధించండి',
    create: 'సృష్టించండి',
    signIn: 'సైన్ ఇన్',
    appearance: 'రూపం: పరికరం థీమ్',
    displayLanguage: 'ప్రదర్శన భాష',
    albums: 'ఆల్బమ్‌లు',
    settings: 'సెట్టింగ్‌లు',
    logout: 'లాగ్ అవుట్',
    help: 'సహాయం & అభిప్రాయం',
    home: 'హోమ్',
    shorts: 'షార్ట్స్',
    subscriptions: 'సబ్‌స్క్రిప్షన్‌లు',
    you: 'మీరు',
    history: 'చరిత్ర',
    playlists: 'ప్లేలిస్ట్‌లు',
    yourVideos: 'మీ వీడియోలు',
    watchLater: 'తర్వాత చూడండి',
    likedVideos: 'ఇష్టపడిన వీడియోలు',
    explore: 'ఎక్స్‌ప్లోర్',
    trending: 'ట్రెండింగ్',
    music: 'సంగీతం',
    gaming: 'గేమింగ్',
    news: 'వార్తలు',
    sports: 'క్రీడలు',
    podcasts: 'పాడ్‌కాస్ట్‌లు',
    welcomeTitle: 'స్పీడోట్యూబ్‌కి స్వాగతం',
    welcomeMessage: 'అత్యుత్తమ వినోదాన్ని ఆస్వాదించడానికి సైన్ ఇన్ చేయండి.',
    exploreAnyways: 'ఎక్స్‌ప్లోర్ చేయండి',
    all: 'అన్నీ',
    live: 'లైవ్',
    views: 'వీక్షణలు',
    daysAgo: 'రోజుల క్రితం',
    hoursAgo: 'గంటల క్రితం',
  },
  kn: {
    search: 'ಹುಡುಕಿ',
    create: 'ರಚಿಸಿ',
    signIn: 'ಸೈನ್ ಇನ್ ಮಾಡಿ',
    appearance: 'ಗೋಚರತೆ: ಸಾಧನದ ಥೀಮ್',
    displayLanguage: 'ಪ್ರದರ್ಶನ ಭಾಷೆ',
    albums: 'ಆಲ್ಬಮ್‌ಗಳು',
    settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    logout: 'ಸೈನ್ ಔಟ್',
    help: 'ಸಹಾಯ ಮತ್ತು ಪ್ರತಿಕ್ರಿಯೆ',
    home: 'ಮುಖಪುಟ',
    shorts: 'ಶಾರ್ಟ್ಸ್',
    subscriptions: 'ಚಂದಾದಾರಿಕೆಗಳು',
    you: 'ನೀವು',
    history: 'ಇತಿಹಾಸ',
    playlists: 'ಪ್ಲೇಪಟ್ಟಿಗಳು',
    yourVideos: 'ನಿಮ್ಮ ವೀಡಿಯೊಗಳು',
    watchLater: 'ನಂತರ ವೀಕ್ಷಿಸಿ',
    likedVideos: 'ಇಷ್ಟಪಟ್ಟ ವೀಡಿಯೊಗಳು',
    explore: 'ಅನ್ವೇಷಿಸಿ',
    trending: 'ಟ್ರೆಂಡಿಂಗ್',
    music: 'ಸಂಗೀತ',
    gaming: 'ಗೇಮಿಂಗ್',
    news: 'ಸುದ್ದಿ',
    sports: 'ಕ್ರೀಡೆ',
    podcasts: 'ಪಾಡ್‌ಕಾಸ್ಟ್‌ಗಳು',
    welcomeTitle: 'ಸ್ಪೀಡೋಟ್ಯೂಬ್‌ಗೆ സ്വാಗತ',
    welcomeMessage: 'ಮನರಂಜನೆಗಾಗಿ ಸೈನ್ ಇನ್ ಮಾಡಿ.',
    exploreAnyways: 'ಅನ್ವೇಷಿಸಿ',
    all: 'ಎಲ್ಲಾ',
    live: 'ಲೈವ್',
    views: 'ವೀಕ್ಷಣೆಗಳು',
    daysAgo: 'ದಿನಗಳ ಹಿಂದೆ',
  },
  ml: {
    search: 'തിരയുക',
    create: 'സൃഷ്ടിക്കുക',
    signIn: 'സൈൻ ഇൻ ചെയ്യുക',
    appearance: 'രൂപം: ഉപകരണ തീം',
    displayLanguage: 'പ്രദർശന ഭാഷ',
    albums: 'ആൽബങ്ങൾ',
    settings: 'ക്രമീകരണങ്ങൾ',
    logout: 'സൈൻ ഔട്ട്',
    help: 'സഹായവും അഭിപ്രായവും',
    home: 'ഹോം',
    shorts: 'ഷോർട്ട്സ്',
    subscriptions: 'സബ്‌സ്‌ക്രിപ്‌ഷനുകൾ',
    you: 'നിങ്ങൾ',
    history: 'ചരിത്രം',
    playlists: 'പ്ലേലിസ്റ്റുകൾ',
    yourVideos: 'നിങ്ങളുടെ വീഡിയോകൾ',
    watchLater: 'പിന്നീട് കാണുക',
    likedVideos: 'ഇഷ്ടപ്പെട്ട വീഡിയോകൾ',
    explore: 'എക്സ്പ്ലോർ ചെയ്യുക',
    trending: 'ട്രെൻഡിംഗ്',
    music: 'സംഗീതം',
    gaming: 'ഗെയിമിംഗ്',
    news: 'വാർത്തകൾ',
    sports: 'കായികം',
    podcasts: 'പോഡ്‌കാസ്റ്റുകൾ',
    welcomeTitle: 'സ്പീഡോട്യൂബിലേക്ക് സ്വാഗതം',
    welcomeMessage: 'വിനോദത്തിനായി സൈൻ ഇൻ ചെയ്യുക.',
    exploreAnyways: 'എക്സ്പ്ലോർ ചെയ്യുക',
    all: 'എല്ലാം',
    live: 'ലൈവ്',
    views: 'കാഴ്ചകൾ',
  },
  ar: {
    search: 'بحث',
    create: 'إنشاء',
    signIn: 'تسجيل الدخول',
    appearance: 'المظهر: مظهر الجهاز',
    displayLanguage: 'لغة العرض',
    albums: 'ألبومات',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    help: 'المساعدة والتعليقات',
    home: 'الصفحة الرئيسية',
    shorts: 'Shorts',
    subscriptions: 'الاشتراكات',
    you: 'أنت',
    history: 'السجل',
    playlists: 'قوائم التشغيل',
    yourVideos: 'فيديوهاتك',
    watchLater: 'المشاهدة لاحقًا',
    likedVideos: 'فيديوهات أعجبتني',
    explore: 'استكشاف',
    trending: 'المحتويات الرائجة',
    music: 'الموسيقى',
    gaming: 'الألعاب',
    news: 'الأخبار',
    sports: 'الرياضة',
    podcasts: 'بودكاست',
    welcomeTitle: 'مرحبًا بك في SpeedoTube',
    welcomeMessage: 'سجل الدخول للاستمتاع بأفضل المحتويات.',
    exploreAnyways: 'استكشف على أي حال',
    all: 'الكل',
    live: 'مباشر',
    views: 'مشاهدة',
  },
  ru: {
    search: 'Поиск',
    create: 'Создать',
    signIn: 'Войти',
    appearance: 'Тема: как на устройстве',
    displayLanguage: 'Язык',
    albums: 'Альбомы',
    settings: 'Настройки',
    logout: 'Выйти',
    help: 'Справка/отзыв',
    home: 'Главная',
    shorts: 'Shorts',
    subscriptions: 'Подписки',
    you: 'Вы',
    history: 'История',
    playlists: 'Плейлисты',
    yourVideos: 'Ваши видео',
    watchLater: 'Смотреть позже',
    likedVideos: 'Понравившиеся',
    explore: 'Навигатор',
    trending: 'В тренде',
    music: 'Музыка',
    gaming: 'Видеоигры',
    news: 'Новости',
    sports: 'Спорт',
    podcasts: 'Подкасты',
    welcomeTitle: 'Добро пожаловать в SpeedoTube',
    welcomeMessage: 'Войдите, чтобы смотреть лучшие видео.',
    exploreAnyways: 'Просмотреть без входа',
    all: 'Все',
    live: 'Прямой эфир',
    views: 'просмотров',
  },
  zh: {
    search: '搜索',
    create: '创建',
    signIn: '登录',
    appearance: '外观：与设备一致',
    displayLanguage: '显示语言',
    albums: '专辑',
    settings: '设置',
    logout: '退出登录',
    help: '帮助和反馈',
    home: '首页',
    shorts: 'Shorts 短视频',
    subscriptions: '订阅',
    you: '媒体库',
    history: '历史记录',
    playlists: '播放列表',
    yourVideos: '你的视频',
    watchLater: '稍后观看',
    likedVideos: '顶过的视频',
    explore: '探索',
    trending: '时下流行',
    music: '音乐',
    gaming: '游戏',
    news: '新闻',
    sports: '体育',
    podcasts: '播客',
    welcomeTitle: '欢迎来到 SpeedoTube',
    welcomeMessage: '登录以享受高品质视频体验。',
    exploreAnyways: '直接探索',
    all: '全部',
    live: '直播',
    views: '次观看',
  },
  ja: {
    search: '検索',
    create: '作成',
    signIn: 'ログイン',
    appearance: 'デザイン: 端末のテーマ',
    displayLanguage: '表示言語',
    albums: 'アルバム',
    settings: '設定',
    logout: 'ログアウト',
    help: 'ヘルプとフィードバック',
    home: 'ホーム',
    shorts: 'Shorts',
    subscriptions: '登録チャンネル',
    you: 'マイページ',
    history: '履歴',
    playlists: '再生リスト',
    yourVideos: '自分の動画',
    watchLater: '後で見る',
    likedVideos: '高く評価した動画',
    explore: '探索',
    trending: '急上昇',
    music: '音楽',
    gaming: 'ゲーム',
    news: 'ニュース',
    sports: 'スポーツ',
    podcasts: 'ポッドキャスト',
    welcomeTitle: 'SpeedoTube へようこそ',
    welcomeMessage: 'ログインして動画コンテンツをお楽しみください。',
    exploreAnyways: 'そのまま探索',
    all: 'すべて',
    live: 'ライブ',
    views: '回視聴',
  },
  ko: {
    search: '검색',
    create: '만들기',
    signIn: '로그인',
    appearance: '디자인: 기기 테마',
    displayLanguage: '표시 언어',
    albums: '앨범',
    settings: '설정',
    logout: '로그아웃',
    help: '고객센터 및 의견 보내기',
    home: '홈',
    shorts: 'Shorts',
    subscriptions: '구독',
    you: '나',
    history: '시청 기록',
    playlists: '재생목록',
    yourVideos: '내 동영상',
    watchLater: '나중에 볼 동영상',
    likedVideos: '좋아요 표시한 동영상',
    explore: '탐색',
    trending: '인기 급상승',
    music: '음악',
    gaming: '게임',
    news: '뉴스',
    sports: '스포츠',
    podcasts: '팟캐스트',
    welcomeTitle: 'SpeedoTube에 오신 것을 환영합니다',
    welcomeMessage: '로그인하여 동영상을 즐겨보세요.',
    exploreAnyways: '둘러보기',
    all: '전체',
    live: '라이브',
    views: '회',
  },
  it: {
    search: 'Cerca',
    create: 'Crea',
    signIn: 'Accedi',
    appearance: 'Aspetto: Tema del dispositivo',
    displayLanguage: 'Lingua di visualizzazione',
    albums: 'Album',
    settings: 'Impostazioni',
    logout: 'Esci',
    help: 'Guida e feedback',
    home: 'Home',
    shorts: 'Shorts',
    subscriptions: 'Iscrizioni',
    you: 'Tu',
    history: 'Cronologia',
    playlists: 'Playlist',
    yourVideos: 'I tuoi video',
    watchLater: 'Guarda più tardi',
    likedVideos: 'Video che ti piacciono',
    yourChannel: 'Il tuo canale',
    downloads: 'Download',
    moreFromSpeedo: 'Altro da Speedo',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Esplora',
    shopping: 'Shopping',
    music: 'Musica',
    movies: 'Film e TV',
    trending: 'Tendenza',
    popular: 'Canali popolari',
    day: 'Video del giorno',
    week: 'Video della settimana',
    month: 'Video del mese',
    year: 'Video dell\'anno',
    showMore: 'Mostra altro',
    showLess: 'Mostra meno',
    gaming: 'Videogiochi',
    news: 'Notizie',
    sports: 'Sport',
    podcasts: 'Podcast',
    welcomeTitle: 'Benvenuto su SpeedoTube',
    welcomeMessage: 'Accedi per scoprire i migliori contenuti.',
    exploreAnyways: 'Esplora comunque',
    all: 'Tutti',
    live: 'Dal vivo',
    views: 'visualizzazioni',
  },
  bs: {
    search: 'Pretraži',
    create: 'Kreiraj',
    signIn: 'Prijavi se',
    appearance: 'Izgled: Tema uređaja',
    displayLanguage: 'Jezik prikaza',
    albums: 'Albumi',
    settings: 'Postavke',
    logout: 'Odjavi se',
    help: 'Pomoć i povratne informacije',
    home: 'Početna',
    shorts: 'Shorts',
    subscriptions: 'Pretplate',
    you: 'Vi',
    history: 'Historija',
    playlists: 'Plejliste',
    yourVideos: 'Vaši videozapisi',
    watchLater: 'Gledaj kasnije',
    likedVideos: 'Sviđali videozapisi',
    yourChannel: 'Vaš kanal',
    downloads: 'Preuzimanja',
    moreFromSpeedo: 'Više od Speedo-a',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Istraži',
    shopping: 'Kupovina',
    music: 'Muzika',
    movies: 'Filmovi i TV',
    trending: 'Popularno',
    popular: 'Popularni kanali',
    day: 'Videozapisi dana',
    week: 'Videozapisi sedmice',
    month: 'Videozapisi mjeseca',
    year: 'Videozapisi godine',
    showMore: 'Prikaži više',
    showLess: 'Prikaži manje',
    gaming: 'Gejming',
    news: 'Vijesti',
    sports: 'Sport',
    podcasts: 'Podkasti',
    welcomeTitle: 'Dobrodošli na SpeedoTube',
    welcomeMessage: 'Prijavite se za uživanje u zabavi.',
    exploreAnyways: 'Ipak istražite',
    all: 'Sve',
    live: 'Uživo',
    views: 'prikaza',
  },
  ca: {
    search: 'Cerca',
    create: 'Crea',
    signIn: 'Inicia la sessió',
    appearance: 'Aspecte: Tema del dispositiu',
    displayLanguage: 'Idioma de visualització',
    albums: 'Àlbums',
    settings: 'Configuració',
    logout: 'Tanca la sessió',
    help: 'Ajuda i suggeriments',
    home: 'Inici',
    shorts: 'Shorts',
    subscriptions: 'Subscripcions',
    you: 'Tu',
    history: 'Historial',
    playlists: 'Llistes de reproducció',
    yourVideos: 'Els teus vídeos',
    watchLater: 'Visualitza més tard',
    likedVideos: 'Vídeos que m\'agraden',
    yourChannel: 'El teu canal',
    downloads: 'Descàrregues',
    moreFromSpeedo: 'Més de Speedo',
    speedoPrime: 'Speedo Prime',
    speedoTV: 'Speedo TV',
    speedoLearning: 'Speedo Learning',
    explore: 'Explora',
    shopping: 'Compres',
    music: 'Música',
    movies: 'Pel·lícules i TV',
    trending: 'Tendències',
    popular: 'Canals populars',
    day: 'Vídeos del dia',
    week: 'Vídeos de la setmana',
    month: 'Vídeos del mes',
    year: 'Vídeos de l\'any',
    showMore: 'Mostra\'n més',
    showLess: 'Mostra\'n menys',
    gaming: 'Videojocs',
    news: 'Notícies',
    sports: 'Esports',
    podcasts: 'Pòdcasts',
    welcomeTitle: 'Benvingut a SpeedoTube',
    welcomeMessage: 'Inicia la sessió per gaudir del millor entreteniment.',
    exploreAnyways: 'Explora de totes maneres',
    all: 'Tot',
    live: 'En directe',
    views: 'visualitzacions',
  },
};

// Universal Translation Lookup Function
export const getTranslation = (key, langCode) => {
  let targetLang = langCode;
  if (!targetLang && typeof localStorage !== 'undefined') {
    try {
      const saved = localStorage.getItem('speedotube_display_language');
      if (saved) {
        const parsed = JSON.parse(saved);
        targetLang = parsed.code;
      }
    } catch (e) {}
  }
  targetLang = (targetLang || 'en').split('-')[0].toLowerCase();

  if (UI_TRANSLATIONS[targetLang] && UI_TRANSLATIONS[targetLang][key]) {
    return UI_TRANSLATIONS[targetLang][key];
  }
  return UI_TRANSLATIONS['en']?.[key] || key;
};

// Permanently Nuke / Delete Google Translate Banner & Tooltip Elements from DOM
export const nukeGoogleBanner = () => {
  if (typeof document === 'undefined') return;

  if (document.body) {
    document.body.style.setProperty('top', '0px', 'important');
    document.body.style.setProperty('position', 'static', 'important');
    document.body.style.setProperty('margin-top', '0px', 'important');
  }
  if (document.documentElement) {
    document.documentElement.style.setProperty('top', '0px', 'important');
    document.documentElement.style.setProperty('margin-top', '0px', 'important');
  }

  const elements = document.querySelectorAll(
    '.goog-te-banner-frame, iframe.goog-te-banner-frame, #goog-gt-tt, .goog-te-balloon-frame, .goog-tooltip, .goog-te-spinner-pos, iframe[id*=":1.container"]'
  );
  elements.forEach((el) => {
    try {
      el.remove();
    } catch (e) {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
    }
  });
};

if (typeof window !== 'undefined') {
  setInterval(nukeGoogleBanner, 40);

  try {
    const observer = new MutationObserver(() => {
      nukeGoogleBanner();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
}

// Google Cloud Translation API Key Configuration
let GOOGLE_TRANSLATE_API_KEY = '';

export const setGoogleTranslateApiKey = (apiKey) => {
  GOOGLE_TRANSLATE_API_KEY = apiKey;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('speedotube_google_translate_api_key', apiKey);
  }
};

export const getGoogleTranslateApiKey = () => {
  if (GOOGLE_TRANSLATE_API_KEY) return GOOGLE_TRANSLATE_API_KEY;
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('speedotube_google_translate_api_key') || '';
  }
  return '';
};

// Official Google Cloud Translation API v2 REST Endpoint Caller
export const translateWithGoogleAPI = async (textArray, targetLang) => {
  const apiKey = getGoogleTranslateApiKey();
  if (!apiKey) {
    return textArray;
  }

  try {
    const response = await fetch(
      `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          q: textArray,
          target: targetLang.split('-')[0].toLowerCase(),
          format: 'text',
        }),
      }
    );

    const data = await response.json();
    if (data && data.data && data.data.translations) {
      return data.data.translations.map((t) => t.translatedText);
    }
  } catch (error) {
    console.error('Google Translation API Error:', error);
  }

  return textArray;
};

// Global Translation Dispatcher (Clean Native Browser Translation - NO Top Banner Bar)
export const applyGlobalTranslation = (langCode) => {
  if (!langCode) return;
  const cleanCode = langCode.split('-')[0].toLowerCase();
  
  if (typeof document !== 'undefined') {
    document.documentElement.lang = cleanCode;

    // Expire & delete legacy googtrans cookies that cause top iframe bar to show up
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.localhost;';

    // Remove legacy script elements or containers
    const scriptEl = document.getElementById('google-translate-script');
    if (scriptEl) scriptEl.remove();

    const elem = document.getElementById('google_translate_element');
    if (elem) elem.remove();
  }

  nukeGoogleBanner();

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('speedotube_language_changed', { detail: { langCode: cleanCode } }));
  }
};






